import type { QuizAttemptPrivate, QuizPrivate } from '@repo/types/quiz';

export type SectionDecision = {
  destination: number | null;
};

export function resolveDestinationSection(params: { quiz: QuizPrivate; attempt: QuizAttemptPrivate; sectionNumber: number }): SectionDecision {
  const instantMark = params.quiz.instantMark;
  const sections = params.attempt.body.metadata.sections;
  const timerAccess = params.attempt.body.metadata.timers.map((t) => t == null || t > 0);
  const isMarked = (id: number) => Boolean(sections.find((s) => s.id === id));

  for (const offset of [0, 1]) {
    const forward = params.sectionNumber + offset;
    if (forward < params.quiz.content.length && (!isMarked(forward) || params.quiz.freeNavigation || instantMark) && timerAccess[forward]) {
      return { destination: forward };
    }
  }

  for (let i = params.sectionNumber + 1; i < params.quiz.content.length; i++) {
    if (!isMarked(i) && timerAccess[i]) return { destination: i };
  }
  for (let i = params.sectionNumber - 1; i >= 0; i--) {
    if (!isMarked(i) && timerAccess[i]) return { destination: i };
  }
  return { destination: null };
}
